import { MarketplaceOfferJsonldMarketplaceOfferRead } from '@/api/generated';
import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import { useCardOfferListApi } from 'hooks/queries/marketplace/offers';
import { useMyWallet } from 'hooks/queries/marketplace/wallet';
import { useRouter } from 'next/router';

const useListOffer = ({
  cardRef,
  itemsPerPage,
  withPagination,
  disabled,
}: {
  cardRef: string;
  itemsPerPage: number;
  withPagination?: boolean;
  disabled: boolean;
}) => {
  const { replaceModal } = useModal();
  const {
    query: { page },
  } = useRouter();
  const { isWalletActivated } = useMyWallet();
  const { queryResult } = useCardOfferListApi({
    cardRef,
    itemsPerPage,
    page: withPagination ? Number(page || 1) : undefined,
    disabled,
  });
  const total = queryResult.data?.data['hydra:totalItems'] || 0;
  const remainingItems = Math.max(total - itemsPerPage, 0);

  const handleOpenManageOfferModal = async () => {
    replaceModal(MODAL_NAME.MANAGE_OFFER, {
      reference: cardRef,
    });
  };

  const handleOpenBuyOfferModal = async (offer: MarketplaceOfferJsonldMarketplaceOfferRead) => {
    if (!isWalletActivated) {
      replaceModal(MODAL_NAME.CMS_MODAL, {
        cmsModalName: 'wallet-eligibility',
      });
    } else {
      replaceModal(MODAL_NAME.BUY_OFFER, {
        reference: cardRef,
        offerId: offer.offerId!,
      });
    }
  };

  return { remainingItems, queryResult, handleOpenManageOfferModal, handleOpenBuyOfferModal, total };
};

export default useListOffer;
